import { Component, Input } from '@angular/core';
import { Notification } from 'src/app/models/Notification';

@Component({
	selector: 'app-single-header-notification',
	templateUrl: './single-header-notification.component.html',
	styleUrls: ['./single-header-notification.component.scss']
})
export class SingleHeaderNotificationComponent {

	@Input() notification! : Notification;
	@Input() icon! : string;
}